import { ServicesService } from "app/pages/services/services.service";
import {
  Component,
  OnInit,
  AfterViewInit,
  ElementRef,
  ViewChild,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  EventEmitter,
} from "@angular/core";
import MetisMenu from "metismenujs/dist/metismenujs";
import { EventService } from "../../core/services/event.service";
import { Router, NavigationEnd, ActivatedRoute, Params } from "@angular/router";

import { HttpClient } from "@angular/common/http";

import { MENU } from "./menu";
import { MenuItem } from "./menu.model";
import { TranslateService } from "@ngx-translate/core";
import { AuthenticationService } from "app/core/services/auth.service";
import { CompaniesService } from "app/view/companies/companies.service";
import { SharedService } from "app/shared/services/shared.service";
import { environment as env } from "@env/environment";
import { FilesService } from "app/shared/services/files.service";
import { Company, DataAllCompanies } from "app/view/companies/modal/companies";
@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
})

/**
 * Sidebar component
 */
export class SidebarComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild("componentRef") scrollRef;
  @Input() isCondensed = false;
  @Output() mobileMenuButtonClicked = new EventEmitter();
  url: string = env.url;
  companyDetails: any;
  loadingShow: boolean = true;
  menu: any;
  data: any;
  companyIds: any[] = [];
  companyID: number = 0;
  menuItems = [];
  loadingCompany: boolean = false;
  @ViewChild("sideMenu") sideMenu: ElementRef;
  USERERP: any;
  language: any;
  allCompanies: DataAllCompanies[] = [];
  // custom drop down list
  dropdownOpen = false;
  selectedCompany: any = { name: null };

  constructor(
    private _CompaniesService: CompaniesService,
    private eventService: EventService,
    public router: Router,
    public translate: TranslateService,
    public _FileServices: FilesService,
    private http: HttpClient,
    public _AuthenticationService: AuthenticationService,
    private _SharedService: SharedService,
    private _ActivatedRoute: ActivatedRoute,
    private ServicesService: ServicesService
  ) {
    this.USERERP = JSON.parse(localStorage.getItem("user_ERP"));
    if (JSON.parse(localStorage.getItem("lang_ERP")))
      this.language = JSON.parse(localStorage.getItem("lang_ERP")).lang;
    else this.language = "ar";
  }

  toggleMobileMenu(event: any) {
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  ngOnInit() {
    this._SharedService.companyID$.subscribe((param) => {
      this.companyID = param;
      // this.showCompany(this.companyID);
    });
    this._SharedService.isReloadeCompany.subscribe((res) => {
      if (res) this.GetCompanyOrThroughToken();
    });
    this.GetCompanyOrThroughToken();
    this._CompaniesService.getAllCompanies().subscribe({
      next: (res: Company) => {
        this.allCompanies = res.data;
      },
      error: (err: Error) => {},
      complete: () =>
        (this.selectedCompany = this.allCompanies.find(
          (item) => item.id == this.companyID
        )),
    });

    // this.ServicesService.getUserCompanies().subscribe({
    //   next: (res: any) => {
    //     this._SharedService.setUserCompanies(res.data);
    //     // this.allUsersCompanies=_SharedService.allUserCompanies.value
    //     // this.companyID=this.allUsersCompanies[0].id
    //     // this.getTasksByCompany(this.allUsersCompanies[0].id)
    //   },
    // });
  }

  ngOnChanges() {
    if ((!this.isCondensed && this.sideMenu) || this.isCondensed) {
      setTimeout(() => {
        this.menu = new MetisMenu(this.sideMenu.nativeElement);
      });
    } else if (this.menu) {
      this.menu.dispose();
    }
  }

  // ---------------- custom drop down list ----------------
  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  selectCompany(id: any) {
    this.selectedCompany = this.allCompanies.find((item) => item.id == id);
    this.dropdownOpen = false;
    this.router.navigate(["/company-details", id]);
  }

  // get elemnts menu
  _MetisMenu() {
    this.menu = new MetisMenu(this.sideMenu.nativeElement);
  }
  toggleMenu(event) {
    event.currentTarget.nextElementSibling.classList.toggle("mm-show");
  }
  checkRouting(route: string): boolean {
    let check = route !== undefined ? route.includes(this.router.url) : false;
    return check;
  }
  checkRoutingShow(route: any[]): boolean {
    if (route.length > 0) {
      route.forEach((res) => {
        if (res.link == this.router.url) {
          console.log(res.link == this.router.url);
          return true;
        }
      });
      return false;
    }
  }
  GetCompanyOrThroughToken() {
    this._CompaniesService.GetCompanyOrThroughToken().subscribe({
      next: (res: any) => {
        this.companyIds = res.data;
        this.initialize();
        this.loadingCompany = true;
      },
    });
  }

  getCompanyName(companyId: number) {
    let company: any = this.companyIds.filter((x) => x.id == companyId);
    return company[0]?.name;
  }

  _scrollElement() {
    setTimeout(() => {
      if (document.getElementsByClassName("mm-active").length > 0) {
        const currentPosition =
          document.getElementsByClassName("mm-active")[0]["offsetTop"];
        if (currentPosition > 500)
          if (this.scrollRef.SimpleBar !== null)
            this.scrollRef.SimpleBar.getScrollElement().scrollTop =
              currentPosition + 300;
      }
    }, 300);
  }

  checkRole(role: string[]) {
    const intersection = role.filter((x) => this.USERERP.roleNames.includes(x));
    return intersection;
  }

  _removeAllClass(className) {
    const els = document.getElementsByClassName(className);
    while (els[0]) {
      els[0].classList.remove(className);
    }
  }

  _activateMenuDropdown() {
    const links = document.getElementsByClassName("side-nav-link-ref");
    let menuItemEl = null;
    const paths = [];
    for (let i = 0; i < links.length; i++) {
      paths.push(links[i]["pathname"]);
    }
    let itemIndex = paths.indexOf(window.location.pathname);
    if (itemIndex === -1) {
      const strIndex = window.location.pathname.lastIndexOf("/");
      const item = window.location.pathname.substr(0, strIndex).toString();
      menuItemEl = links[paths.indexOf(item)];
    } else {
      menuItemEl = links[itemIndex];
    }
    if (menuItemEl) {
      menuItemEl.classList.add("active");
      const parentEl = menuItemEl.parentElement;
      if (parentEl) {
        parentEl.classList.add("mm-active");
        const parent2El = parentEl.parentElement.closest("ul");
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.add("mm-show");
          const parent3El = parent2El.parentElement;
          if (parent3El && parent3El.id !== "side-menu") {
            parent3El.classList.add("mm-active");
            const childAnchor = parent3El.querySelector(".has-arrow");
            const childDropdown = parent3El.querySelector(".has-dropdown");
            if (childAnchor) {
              childAnchor.classList.add("mm-active");
            }
            if (childDropdown) {
              childDropdown.classList.add("mm-active");
            }
            const parent4El = parent3El.parentElement;
            if (parent4El && parent4El.id !== "side-menu") {
              parent4El.classList.add("mm-show");
              const parent5El = parent4El.parentElement;
              if (parent5El && parent5El.id !== "side-menu") {
                parent5El.classList.add("mm-active");
                const childanchor = parent5El.querySelector(".is-parent");
                if (childanchor && parent5El.id !== "side-menu") {
                  childanchor.classList.add("mm-active");
                }
              }
            }
          }
        }
      }
    }
  }

  initialize() {
    this.FetchMenue()
      .then((m: any) => (this.menuItems = m))
      .finally(() =>
        setTimeout(() => {
          this._MetisMenu();
        }, 100)
      );
  }

  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }

  ngOnDestroy(): void {
    this.USERERP = null;
  }

  FetchMenue() {
    const menu: MenuItem[] = [
      // {
      //   id: 1,
      //   label: 'MENUITEMS.MENU.TEXT',
      //   isTitle: true,
      //   role: ['Admin', 'Superadmin', 'User', 'DepartmentAdmin'],
      //   permission: '',
      // },
      {
        id: 2,
        label: "MENUITEMS.DASHBOARDS.TEXT",
        icon: "smart-home",
        link: "/account/all-companies",
        role: ["Superadmin"],
        permission: ["ViewCompanies"],
        // permission: ['Permissions.Companies.All'],
      },
      // {
      //   id: 3,
      //   isLayout: true,
      //   role: ['Admin', 'Superadmin', 'User', 'DepartmentAdmin'],
      //   permission: []
      // },
      // {
      //   id: 4,
      //   label: 'MENUITEMS.APPS.TEXT',
      //   isTitle: true,
      //   role: ['Admin', 'Superadmin', 'User', 'DepartmentAdmin'],
      //   permission: []
      // },
      {
        id: 7,
        icon: "stack-3",
        label: "MENUITEMS.PROJECTS.TEXT",
        link: `/companies/projects`,
        // permission: ['Permissions.Projects.All'],
        permission: ["ViewProjects"],
        // badge: {
        //   variant: 'success',
        //   text: '2',
        // },
        subItems: [],
      },
      {
        id: 20,
        icon: "list-check",
        label: "MENUITEMS.TASKS.TEXT2",
        link: `/companies/tasks-without-project`,
        // permission: ['Permissions.Tasks.All'],
        permission: ["ViewTasks"],
        // badge: {
        //   variant: 'success',
        //   text: '2',
        // },
        subItems: [],
      },
      {
        id: 21,
        icon: "list-check",
        label: "MENUITEMS.TASKS.ACHIEVED",
        link: `/companies/achieved-tasks`,
        // permission: ['Permissions.Tasks.All'],
        permission: ["ViewTasks"],
        subItems: [],
      },

      // ----------------- MANGEMENT Module Routes -------------------
      {
        id: 9,
        icon: "settings",
        label: "MENUITEMS.MANGEMENT.TEXT",
        role: ["Superadmin"],
        // permission: ['Permissions.Auth.All'],
        permission: ["ViewAdministration"],
        subItems: [
          {
            id: 2,
            label: "MENUITEMS.COMPANIES.TEXT",
            icon: "bx-home-circle",
            link: "/companies",
            role: ["Superadmin"],
            // permission: ['Permissions.Companies.All'],
            permission: ["ViewCompanies"],
          },
          {
            id: 8,
            label: "GENERAL.productsClasification",
            icon: "bx-home-circle",
            link: `sales/item-category`,
            role: ["Superadmin"],
            // permission: ['Permissions.Items.All', 'Permissions.ItemCategories.All'],
            permission: ["ViewProduct"],
          },
          {
            id: 10,
            label: "MENUITEMS.MANGEMENT.LIST.USERS",

            link: `/mangement/user-role`,
            parentId: 4,
            role: ["Superadmin"],
            // permission: ['Permissions.Auth.All'],
            permission: ["ViewUser"],
          },
          {
            id: 11,
            label: "MENUITEMS.MANGEMENT.LIST.ROLES",
            link: "/mangement/role",
            parentId: 5,
            role: ["Superadmin"],
            // permission: ['Permissions.Auth.All'],
            permission: ["ViewRole"],
          },
          {
            id: 11,
            label: "MENUITEMS.SERVICES.TEXT",
            link: "/services",
            parentId: 6,
            role: ["Superadmin"],
            // permission: ['Permissions.Auth.All'],
            permission: ["ViewService"],
          },
          {
            id: 12,
            label: "MENUITEMS.Domains.title",
            link: "/mangement/domains",
            parentId: 6,
            role: ["Superadmin"],
            // permission: ['Permissions.Auth.All'],
            permission: ["ViewScope"],
          },
        ],
      },

      // ----------------- FINANCES Module Routes -------------------
      {
        id: 9,
        icon: "coin",
        label: "FINANCES.TEXT",
        link: ``,
        // permission: ['Permissions.Vouchers.All'],
        permission: ["ViewFinance"],
        subItems: [
          {
            id: 1,
            label: "FINANCES.accounts",
            icon: "bx-home-circle",
            link: `/companies/new-finances/accounts`,
            permission: ["ViewFinance"],
            role: ["Superadmin"],
          },
          {
            id: 2,
            label: "FINANCES.New",
            icon: "bx-home-circle",
            // link: `/companies/new-finances/entries`,
            permission: ["ViewFinance"],
            role: ["Superadmin"],
            subItems: [
              {
                id: 2,
                label: "FINANCES.entries",
                icon: "bx-home-circle",
                link: `/companies/new-finances/entries`,
                permission: ["ViewFinance"],
                role: ["Superadmin"],
              },

              {
                id: 20,
                label: "FINANCES.bill_voucher",
                icon: "bx-home-circle",
                link: `companies/new-finances/bill-voucher`,
                permission: ["ViewFinance"],
                role: ["Superadmin"],
              },
              {
                id: 3,
                label: "FINANCES.payment_voucher",
                icon: "bx-home-circle",
                link: `companies/new-finances/payment-voucher`,
                permission: ["ViewFinance"],
                role: ["Superadmin"],
              },
            ],
          },
          // {
          //   id: 3,
          //   label: "FINANCES.accounts",
          //   icon: "bx-home-circle",
          //   link: `companies/new-finances/accounts`,
          //   permission: ["ViewFinance"],
          //   role: ["Superadmin"],
          // },
          {
            id: 4,
            label: "FINANCES.cash_and_banks",
            icon: "bx-home-circle",
            link: `companies/new-finances/payment-method`,
            permission: ["ViewFinance"],
            role: ["Superadmin"],
          },
          {
            id: 5,
            label: "FINANCES.employee_accounts",
            icon: "bx-home-circle",
            link: `companies/new-finances/Employee-Accounts`,
            permission: ["ViewFinance"],
            role: ["Superadmin"],
          },
          {
            id: 6,
            label: "FINANCES.asset",
            icon: "bx-home-circle",
            link: `companies/new-finances/assets`,
            permission: ["ViewFinance"],
            role: ["Superadmin"],
          },
          {
            id: 7,
            label: "FINANCES.tax",
            icon: "bx-home-circle",
            link: `companies/new-finances/taxs`,
            permission: ["ViewFinance"],
            role: ["Superadmin"],
          },
          {
            id: 13,
            label: "MENUITEMS.CLIENTS.TEXT",
            icon: "bx-home-circle",
            link: `companies/new-finances/clients`,
            permission: ["ViewFinance"],
            role: ["Superadmin"],
          },

          {
            id: 2,
            label: "FINANCES.EXPENSES",
            icon: "bx-home-circle",
            link: `/companies/finances/expenses`,
            permission: ["Permissions.Vouchers.All"],
            role: ["Superadmin"],
          },
          {
            id: 3,
            label: "MENUITEMS.TREASURIES.TEXT",
            icon: "bx-home-circle",
            link: `/companies/finances/treasuries`,
            permission: ["Permissions.TreasuryBranches.All"],
            role: ["Superadmin"],
          },
          {
            id: 4,
            label: "FINANCES.PAYMENTGATEWAY",
            icon: "bx-home-circle",
            link: `/companies/finances/payment-gateway`,
            permission: ["Permissions.PaymentGatway.All"],
            role: ["Superadmin"],
          },
          {
            id: 6,
            label: "FINANCES.vouchersCategories",
            icon: "bx-home-circle",
            link: `/companies/finances/voucher-category`,
            role: ["Superadmin"],
            permission: ["Permissions.VoucherCategories.All"],
          },
          {
            id: 5,
            label: "FINANCES.AccountLogs",
            icon: "bx-home-circle",
            link: `/companies/finances/treasury-account-logs`,
            permission: ["Permissions.AccountLogs.All"],
            role: ["Superadmin"],
          },
          {
            id: 35,
            label: "FINANCES.RecipientType",
            icon: "bx-home-circle",
            link: `/companies/finances/beneficiary-type`,
            role: ["Superadmin"],
            permission: ["Permissions.VoucherCategories.All"],
          },
        ],
      },

      // ----------------- Clients Module Routes -------------------
      {
        id: 999,
        icon: "users",
        label: "MENUITEMS.CLIENTS.TEXT",
        link: ``,
        // permission: ['Permissions.Clients.All'], // will be replaced
        permission: ["ViewFinance"],
        subItems: [
          {
            id: 99,
            label: "VIEWCLIENTS.COMPANYCLIENT",
            icon: "bx-home-circle",
            link: `/clients`,
            role: ["Superadmin"],
            // permission: ['Permissions.Clients.All'], // will be replaced
            permission: ["ViewFinance"],
          }
          ,
          // {
          //   id: 92,
          //   label: "VIEWCLIENTS.REQUIRED_SERVICE",
          //   icon: "bx-home-circle",
          //   link: `/clients/required-services`,
          //   role: ["Superadmin"],
          //   // permission: ['Permissions.Clients.All'], // will be replaced
          //   permission: ["ViewFinance"],
          // },
        ],
      },

      // ----------------- HR Module Routes -------------------
      {
        id: 60,
        label: "HR",
        icon: "replace",
        // role: ['Superadmin'],
        // permission: ['Permissions.EmployeeRequests.All'],
        permission: ["ViewHr"],
        subItems: [
          {
            id: 61,
            icon: "bx bx-cog",
            // permission: ['Permissions.EmployeeRequests.All'],
            permission: ["EmployeeRequest"],
            // role: ['Superadmin'],
            label: "MENUITEMS.EMPLOYEES_REQUESTS.TEXT",
            link: `/companies/employees-requests`,
          },
          {
            id: 6,
            icon: "mdi mdi-toolbox-outline",
            label: "MENUITEMS.JOBS.TEXT",
            link: `/companies/jobs`,
            // permission: ['Permissions.Jobs.All'],
            permission: ["ViewJob"],
          },
          {
            id: 6,
            icon: "mdi mdi-toolbox-outline",
            label: "GENERAL.FINGER_PRINT",
            link: `companies/employees-requests/finger-print`,
            // permission: ['Permissions.Jobs.All'],
            permission: ["ViewJob"],
          },
          {
            id: 8,
            icon: "mdi mdi-account-multiple-outline",
            label: "MENUITEMS.EMPLOYEES.TEXT",
            link: `/companies/employees`,
            // permission: ['Permissions.Employees.All'],
            permission: ["ViewEmployee"],
            // badge: {
            //   variant: 'success',
            //   text: '2',
            // },
            subItems: [],
          },
          {
            id: 62,
            icon: "bx bx-cog",
            // permission: ['Permissions.EmployeePermissionApproval.Create'],
            permission: ["Permissions.EmployeePermissionApproval.Create"],
            // role: ['Superadmin'],
            label: "MENUITEMS.EMPLOYEES_REQUESTS.TEXT2",
            link: `/companies/employees-requests/control`,
          },
          {
            id: 5,
            icon: "mdi mdi-graph",
            label: "MENUITEMS.DEPARTMENTS.TEXT",
            link: `/companies/departments`,
            // permission: ['Permissions.Departments.All'],
            permission: ["ViewDepartments"],
            // permission: ['ViewDepartments'],
          },
          {
            id: 62,
            icon: "bx bx-cog",
            // permission: ['Permissions.EmployeeRequests.All'],
            permission: ["ViewEmployeeRequest"],
            // role: ['Superadmin'],
            label: "MENUITEMS.EMPLOYEES_REQUESTS.TEXT3",
            link: `/companies/employees-requests/requests-for-supervisors`,
          },
        ],
      },
        // CRM Module Routes
        /// stop for now
        // {
        //   id: 93,
        //   icon: "users",
        //   label: "crm.crm",
        //   link: `/crm`,
        //   permission: ["ViewProjects"],

        // }
      // {
      //   id: 25,
      //   icon: 'shopping-cart',
      //   label: 'sales.text',
      //   link: `sales/${this.companyID}`,
      //   permission: ['Permissions.Items.All', 'Permissions.ItemCategories.All'],
      //   subItems: [
      //     {
      //       id: 35,
      //       label: 'sales.itemCategory',
      //       icon: 'bx-home-circle',
      //       link: `sales/${this.companyID}/item-category`,
      //       role: ['Superadmin'],
      //       permission: ['Permissions.ItemCategories.All'],
      //     },
      //     {
      //       id: 35,
      //       label: 'sales.items',
      //       icon: 'bx-home-circle',
      //       link: `sales/${this.companyID}/items`,
      //       role: ['Superadmin'],
      //       permission: ['Permissions.Items.All'],
      //     }
      //   ]
      // },

    ];

    return new Promise((resolve, reject) => {
      resolve(menu);
    });
  }

  // showCompany(companyID: number) {
  //   this._CompaniesService.getCompanyById(companyID).subscribe({
  //     next: (res: any) => {
  //       this.loadingShow = false;
  //       this.companyDetails = res.data;
  //     },
  //     error: (err: Error) => {
  //       this.loadingShow = false;
  //     },
  //   });
  // }

}
